import React from "react";
import type { SelectedAccessory, OrderCodePartStrict } from "stores/product";
import { OrderCodePart } from "components/ProductConfigurator/components/OrderCodeForm/components/OrderCodePart";
import { ExpandableText } from "components/ExpandableText/ExpandableText";
import { getAccessoryFromGroup } from "stores/product";
import { ProductImage } from "components/ProductImage";

type SelectedAccessoryDetailsProps = {
  selectedAccessory: SelectedAccessory;
};

export const SelectedAccessoryDetails = ({
  selectedAccessory,
}: SelectedAccessoryDetailsProps) => {
  const presentation = selectedAccessory?.currentPresentation;
  const accessory = presentation
    ? getAccessoryFromGroup(presentation, selectedAccessory?.accessoryGroupId)
    : null;

  const presentationParts =
    accessory?.ordercode?.parts?.filter(
      (part) =>
        // 0 - RelevantChangeable; 1 - RelevantNotChangeable
        // https://dev.azure.com/DEVLY-IT-Software-Development/TROX-EB-Website_v2/_wiki/wikis/TROX-System-Configurator.wiki/1132/Product-states
        part?.state === 0 ||
        part?.state === 1 ||
        (part?.state === 3 && part?.presentation),
    ) || [];

  return (
    accessory &&
    !!accessory.seriesId && (
      <div className="mt-2 d-flex align-items-start gap-4 flex-column">
        <div className="d-flex p-3 align-items-center flex-wrap">
          {accessory.pimId && (
            <div
              className="flex-shrink-0 me-5"
              style={{ width: "100px", height: "100px" }}
            >
              <ProductImage
                pimId={accessory.pimId}
                width={100}
                height={100}
                productName={accessory.currentPresentation || ""}
              />
            </div>
          )}
          <div className="align-self-center flex-shrink-0">
            <div className="d-flex gap-1 align-items-center mb-2 ">
              <h3 className="mb-0" style={{ fontSize: "20px" }}>
                {accessory.currentPresentation?.replace(/\//g, " ")}
              </h3>
            </div>
            <div className="d-flex flex-wrap gap-2 pe-none opacity-50">
              {presentationParts.map((part) => (
                <OrderCodePart
                  key={part?.key}
                  part={part as OrderCodePartStrict}
                  isModal={true}
                />
              ))}
            </div>
          </div>
        </div>
        {accessory.infoText && (
          <ExpandableText>{accessory.infoText}</ExpandableText>
        )}
      </div>
    )
  );
};
